<template>
  <b-alert :variant="alertVariant" :show="alertShow" @dismissed="dismissMessage" dismissible>
    <div v-html="alertInfo"></div>
  </b-alert>
</template>

<script>

export default {
  name: 'AlertHandler',
  data () {
    return {
      alertInfo: '',
      alertVariant: 'info',
      alertShow: false
    }
  },
  methods: {
    reset () {
      this.alertInfo = ''
      this.alertVariant = 'success'
      // this.alertShow = false
    },
    dismissMessage () {
      this.reset()
      this.alertShow = false
    },
    appendMessage (msg, isError = false) {
      this.alertInfo += msg
      if (isError) this.alertVariant = 'success'
      this.alertShow = true
    },
    reportApiError (errMsg) {
      this.alertInfo = errMsg
      this.alertVariant = 'danger'
      this.alertShow = true
    }
  }
}
</script>



// WEBPACK FOOTER //
// AlertHandler.vue?686e9d94